export const createPathWithPathQuery = (path: string, pathQuery: string) => {
  return path + pathQuery;
};
